/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import Icon from "vux/src/components/icon/index.vue";
import Loading from "vux/src/components/loading/index.vue";
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import { target2 } from '@root/_target.js';
import QsyFileUpload from '@/components/CustomFormList/QsyFileUpload';
export default {
  components: {
    QsyFileUpload: QsyFileUpload,
    Icon: Icon,
    Loading: Loading
  },
  directives: {
    TransferDom: TransferDom
  },
  props: {
    title: {
      type: String,
      default: '附件'
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    num: {
      type: Number,
      default: 9
    },
    hiddenBorder: {
      type: Boolean,
      default: false
    },
    target: {
      type: String,
      default: '/upload/h5/save'
    },
    action: {
      type: String,
      default: 'POST'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      hasTitleSlot: false,
      loadingShow: false,
      progress: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('globalStore', ['config'])), {}, {
    realtarget: function realtarget() {
      return target2 + this.target;
    },
    isUpperLimit: function isUpperLimit() {
      return this.currValue.length === this.num;
    }
  }),
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val);
      this.$emit('input', val);
    }
  },
  methods: {
    translate: function translate(str) {
      return str.slice(str.indexOf('-') + 1);
    },
    start: function start(e) {
      this.loadingShow = true;
    },
    finish: function finish(e) {
      this.loadingShow = false;

      if (e.currentTarget.status === 200) {
        var res = JSON.parse(e.currentTarget.response);

        if (res) {
          if (res.success) {
            res.url = res.data.fileUrl + res.data.files;
            this.currValue = this.currValue.concat([{
              file_type: 2,
              file_url: res.url
            }]);
          } else {
            this.$vux.toast.text(res.message);
          }
        } else {
          console.error('上传出错，请重试。。。');
        }
      } else {
        console.error(e.currentTarget.statusText);
      }
    },
    clickUpload: function clickUpload() {
      this.$vux.toast.text("\u6587\u4EF6\u6700\u591A".concat(this.num, "\u4E2A"));
    },
    deleteImg: function deleteImg(index) {
      this.currValue.splice(index, 1);
    },
    show: function show(index) {
      var _this = this;

      return;
      this.$nextTick(function () {
        _this.$refs['previewer'].show(index);
      });
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
  }
};